import React from 'react';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="mt-12 border-t border-amber-200 pt-6" data-id="element-109">
      <div className="mb-8 bg-amber-50 p-5 rounded-lg border border-amber-200" data-id="element-110">
        <h3 className="text-xl font-semibold text-amber-800 mb-3 text-center" data-id="element-111">
          Sammanfattning: Varför välja Brainy?
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-112">
          <div data-id="element-113">
            <ul className="space-y-2" data-id="element-114">
              <li className="flex items-start" data-id="element-115">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-116" />
                <span data-id="element-117">Kliniskt testade ingredienser i optimala doser</span>
              </li>
              <li className="flex items-start" data-id="element-118">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-119" />
                <span data-id="element-120">Bioaktiva former för maximal absorption</span>
              </li>
              <li className="flex items-start" data-id="element-121">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-122" />
                <span data-id="element-123">
                  Synergistisk formula som stödjer hela hjärnans funktion
                </span>
              </li>
            </ul>
          </div>
          <div data-id="element-124">
            <ul className="space-y-2" data-id="element-125">
              <li className="flex items-start" data-id="element-126">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-127" />
                <span data-id="element-128">Inga stimulantia eller biverkningar</span>
              </li>
              <li className="flex items-start" data-id="element-129">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-130" />
                <span data-id="element-131">180 dagars pengarna-tillbaka-garanti</span>
              </li>
              <li className="flex items-start" data-id="element-132">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-133" />
                <span data-id="element-134">Tillverkas i Sverige under GMP-certifiering</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="text-center mb-6" data-id="element-135">
        <p className="text-gray-600 mb-4" data-id="element-136">
          <span className="font-medium" data-id="element-137">Tänk på det:</span> Varje dag utan rätt
          näring förlorar din hjärna tusentals celler som aldrig kommer
          tillbaka.
        </p>
        <a href="https://addrevenue.io/t?c=3462679&a=986619&l=165" target="_blank" rel="noopener noreferrer" className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-lg text-center transition duration-300 shadow-md animate-pulse-slow" data-id="element-138">
          Säkra din hjärnhälsa nu{' '}
          <ArrowRightIcon className="h-4 w-4 inline ml-1" data-id="element-139" />
        </a>
        <p className="text-sm text-gray-500 mt-3" data-id="element-140">
          Endast 17 paket kvar till detta pris • Erbjudandet upphör snart
        </p>
      </div>
      <div className="text-center text-xs text-gray-500 border-t border-amber-200 pt-4" data-id="element-141">
        <p className="mb-2" data-id="element-142">
          Detta är ett sponsrat innehåll. Brainy är ett kosttillskott och inte
          avsett att diagnostisera, behandla, bota eller förebygga någon
          sjukdom. Resultaten kan variera från person till person. Konsultera
          med sjukvårdspersonal innan du börjar med något kosttillskott,
          särskilt om du har en medicinsk åkomma eller tar läkemedel.
        </p>
        <p data-id="element-143">
          © {new Date().getFullYear()} Vitaliv AB. Alla rättigheter
          förbehållna.
        </p>
      </div>
    </footer>;
}